export const AdminRoute = {
  ADMINPAGE: 'adminpage',
  ADMINPANEL: 'adminpanel',
  AI_TOOLS: 'ai-tools',
  ANNOUNCEMENT_MANAGEMENT: 'announcement-management',
  LOCALIZATION: 'localization',
  FEATUREFLAGS: 'feature-flags',
  PERMISSIONS_SETS: 'permission-sets',
  EMAILTEMPLATES: 'email-templates',
  WORKFLOWS: 'workflows'
};
